import styles from "./styles.css";

export default function RotatePhone() {
    return <div className="phone-wrapper">
        <div>
            <div className="static-phone"></div>
            <div className="animated-phone"></div>
        </div>
    </div >;
}